export const featuresFlag = {
  VIRTUAL_CONSOLE: 1,
  ENABLE_QUICK_CHECK: 2,
  SIMPLIFIED_REPORT: 3,
  BINOCULAR_EXAM: 4,
  AVAILABLE_LANGUAGES: 5,
  FAR_VISION_OPTOTYPES: 6,
  SMOKE_TEST_EXAM_START_VALUES: 7,
  GLASS_SELECTION_MODULE: 8,
  BINOCULAR_VISION_SCORING: 9,
  SELF_REF: 10,
  DISABLE_WEB_CLIENT_ACCESS: 11,
  SSO: 12,
  OCR_MODULE: 13,
  BARTI_EXPORT: 14,
  EHR_EXPORT: 15
}

export function getFeaturesFlagKey(value) {
  const key = Object.keys(featuresFlag).find(key => featuresFlag[key] === value)
  return key
}
